<div class="d-flex justify-content-center">
  <div class="col-12">
    @if (jobs && jobs.length > 0) {
      @for (job of jobs; track trackId) {
        <div class="row pt-3 pb-3 border-bottom">
          <div class="col-12 col-md-3 mb-3">
            @if (job.image) {
              <a [routerLink]="['/job', 'public', job.id]">
                <img
                  [src]="'data:' + job.imageContentType + ';base64,' + job.image"
                  class="img-fluid img-thumbnail"
                  alt="..."
                  style="width: 100%"
                />
              </a>
            }
          </div>
          <div class="col-12 col-md-9">
            <h4>
              <span>{{ job.title }}</span>
            </h4>
            <p>
              {{ job.shortDescription }}
            </p>
            <a [routerLink]="['/job', 'public', job.id]" class="btn-link">
              <span>Read more</span>
            </a>
          </div>
        </div>
      }
    }
    @if (jobs && jobs.length > 0) {
      <div>
        <div class="d-flex justify-content-center">
          <jhi-item-count [params]="{ page: page, totalItems: totalItems, itemsPerPage: itemsPerPage }"></jhi-item-count>
        </div>

        <div class="d-flex justify-content-center">
          <ngb-pagination
            [collectionSize]="totalItems"
            [page]="page"
            [pageSize]="itemsPerPage"
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true"
            (pageChange)="navigateToPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    }
  </div>
</div>
